import styled from 'styled-components';

const SearchGroupStyled = styled.div`
  height: 106px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  .card-content {
    padding: 24px 32px 34px;
    display: flex;
    .left {
      flex-grow: 1;
      .line {
        display: flex;
        gap: 48px;
        > div {
          flex: 1;
        }
      }
    }
    .button-group {
      margin-left: 48px;
      .reset {
        margin-right: 16px;
      }
    }
  }
`;

export default SearchGroupStyled;
